"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.tags.placeholder': 'Inserisci tag separati da virgole',
    'knowledge.tags.help': 'Premi Invio per aggiungere ogni tag',
};
